import { useTranslation } from 'react-i18next';
import { CardIcon } from '../../icons';
import { NotYetListItem } from './NotYetListItem';

export function NoCardsListItem() {
  const { t } = useTranslation();
  return <NotYetListItem icon={<CardIcon />} title={t('No cards yet')} />;
}
